import e1 from './e1.json';
import e2 from './e2.json';
import e3 from './e3.json';

export default function getConfig(env) {
  switch (env) {
    case "e1":
      return e1;
    case "e2":
      return e2;
    case "e3":
      return e3;
    default:
      return e1;
  }
}